<template>
	<div class="answer-radio position-rel display-flex">
		<input :name="nameField" type="radio" v-model="value" :value="dataSource.content ? dataSource.content.toLowerCase() : dataSource.imageUrl.toLowerCase()" :checked="(answerContent.toLowerCase())" @click="handleClick" @change="changeAnswer($event, {location, data: parent.type, questionId: dataSource.questionId})">
		&nbsp;
		<label class="display-flex-center">
			<b :class="{'answer-true':checkAnswerTrue(),'answer-false':checkAnswerFalse()}" v-if="dataSource.code">{{ dataSource.code }} </b>
			<span class="custom-content" :class="{'answer-true':checkAnswerTrue(),'answer-false':checkAnswerFalse()}" v-html="dataSource.content"></span>
		</label>
	</div>
</template>

<script>
import mixinsQuestionPreview from "./../../_store/mixinsQuestionPreview";
	export default {
        props:{
            valueSelected:{
                type:String,
                default:''
            },
			answerContent:{
				type:String,
                default:''
			},
			statusUserExcercise:{
				type:Number,
				default:0
			}
        },
		name: 'MultipleChoiceNew',
		mixins: [ mixinsQuestionPreview ],
		watch:{
			valueSelected(){
				this.value = this.valueSelected?this.valueSelected.toLowerCase():''
				console.log(this.value)
				if(this.statusUserExcercise==1){
					if(!this.value){
						this.value = this.answerContent.toLowerCase()
					}
				}
			}
			
		},
        mounted(){
			
            this.value = this.valueSelected?this.valueSelected.toLowerCase():''
			console.log(this.value)
			if(this.statusUserExcercise==1){
				if(!this.value){
					this.value = this.answerContent.toLowerCase()
				}
			}
        },
		data () {
			return {
				value:''
			}
		},
		methods: {
			handleClick(e){
				if(this.statusUserExcercise==1 ||this.statusUserExcercise==2){
					e.preventDefault();
				}
			},
			checkAnswerFalse(){
				if(this.statusUserExcercise ==0||this.statusUserExcercise ==2){
					return false
				}
				if((this.dataSource.content ? this.dataSource.content.toLowerCase() : this.dataSource.imageUrl.toLowerCase()) == this.value){
					return true
				}
				else{
					return false
				}
			},
			checkAnswerTrue(){
				if(this.statusUserExcercise ==0||this.statusUserExcercise ==2){
					return 0
				}
				if((this.dataSource.content ? this.dataSource.content.toLowerCase() : this.dataSource.imageUrl.toLowerCase()) == this.answerContent.toLowerCase()){
					return true
				}
				else{
					return false
				}
			}
		}
	}
</script>
<style>
.custom-content p{
	margin-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
.answer-true{
	color: green !important;
	
	img{
		background-color: green;
		color: green !important;
	}
}
.answer-false{
	color: red;
	img{
		background-color: red;
		color: red;
	}
}
</style>